/** Global class names for Swiper pagination (CSS Modules hashes break querySelector). */
export const SWIPER_BULLET_CLASS = "sector-swiper-bullet";
export const SWIPER_BULLET_ACTIVE_CLASS = "sector-swiper-bullet-active";

export const getSwiperPaginationConfig = (overrides = {}) => ({
    clickable: true,
    bulletClass: SWIPER_BULLET_CLASS,
    bulletActiveClass: SWIPER_BULLET_ACTIVE_CLASS,
    ...overrides,
});
